module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-new-rent"
  }, [_c('h2', [_vm._v("按日续交租金")]), _vm._m(0), _c('el-form', {
    staticClass: "ui form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('div', {
    staticClass: "three fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "date_start"
    }
  }, [_c('label', [_vm._v("开始日期")]), _c('datepicker', {
    attrs: {
      "placeholder": "开始日期",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.form.date_start),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_start", $$v)
      },
      expression: "form.date_start"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "rent_day"
    }
  }, [_c('label', [_vm._v("时长 (日)")]), _c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 30
    },
    model: {
      value: (_vm.form.rent_day),
      callback: function($$v) {
        _vm.$set(_vm.form, "rent_day", $$v)
      },
      expression: "form.rent_day"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "date_end"
    }
  }, [_c('label', [_vm._v("结束日期")]), _c('datepicker', {
    attrs: {
      "placeholder": "结束日期",
      "min": _vm.form.date_start,
      "max": _vm.date_contract_end
    },
    model: {
      value: (_vm.form.date_end),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_end", $$v)
      },
      expression: "form.date_end"
    }
  })], 1)], 1), _c('div', {
    staticClass: "three fields"
  }, [_c('el-form-item', {
    staticClass: "field required",
    attrs: {
      "prop": "price_day"
    }
  }, [_c('label', [_vm._v("日租金 (租金+管理費) / 30")]), _c('el-input-number', {
    attrs: {
      "type": "number",
      "controls": false
    },
    model: {
      value: (_vm.form.price_day),
      callback: function($$v) {
        _vm.$set(_vm.form, "price_day", $$v)
      },
      expression: "form.price_day"
    }
  })], 1), _c('el-form-item', {
    staticClass: "field required",
    attrs: {
      "prop": "amount_due"
    }
  }, [_c('label', [_vm._v("应付租金")]), _c('el-input-number', {
    attrs: {
      "type": "number",
      "disabled": "disabled",
      "controls": false
    },
    model: {
      value: (_vm.form.amount_due),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount_due", $$v)
      },
      expression: "form.amount_due"
    }
  })], 1), _c('el-form-item', {
    staticClass: "field required",
    attrs: {
      "prop": "amount_paid"
    }
  }, [_c('label', [_vm._v("实收租金")]), _c('el-input-number', {
    attrs: {
      "type": "number",
      "controls": false
    },
    model: {
      value: (_vm.form.amount_paid),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount_paid", $$v)
      },
      expression: "form.amount_paid"
    }
  })], 1)], 1), _c('div', {
    staticClass: "three fields"
  }, [_c('el-form-item', {
    staticClass: "field",
    attrs: {
      "prop": "payment_method"
    }
  }, [_c('label', [_vm._v("支付方式")]), _c('payment-method-select', {
    model: {
      value: (_vm.form.payment_method),
      callback: function($$v) {
        _vm.$set(_vm.form, "payment_method", $$v)
      },
      expression: "form.payment_method"
    }
  })], 1)], 1), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "note"
    }
  }, [_c('label', [_vm._v("备注")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "ui field"
  }, [_c('receipts', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receipts && _vm.receipts.length),
      expression: "receipts && receipts.length"
    }],
    attrs: {
      "receipts": _vm.receipts
    }
  })], 1), _c('div', {
    staticClass: "ui field"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认缴交")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon warning message"
  }, [_c('i', {
    staticClass: "warning icon"
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("非正常業務")]), _c('p', [_vm._v("非特殊情況請勿使用此功能")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03d91a16","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormNewRentByDay.vue
// module id = 401
// module chunks = 0